/** "1 report", "3 reports": a count with its noun, for sentences a person reads. */
export const counted = (count: number, noun: string) => `${count} ${noun}${count === 1 ? '' : 's'}`
